import { useRef, useEffect } from 'react'
import * as store from '@store'
import { useWireState, useWireValue } from '@forminator/react-wire'
import { NOTIFICATION_TARGET_ORGANIZATION, RT_EVENT_TYPE_UPDATE_CREDITS } from '@/constants/realtime'
import { toast } from 'react-toastify'

export const useRealtimeUpdateCredits = () => {
    
    const toastId = useRef(null)
    
    const notifications = useWireValue(store.notifications)
    const [credits, setCredits] = useWireState(store.credits)
    const remoteConfig = useWireValue(store.remoteConfig)
    
    useEffect(() => {
        
        if (!remoteConfig?.realtimeEnabled) {
            console.warn('useRealtimeUpdateCredits#remoteConfig.realtimeEnabled is false')
            return
        }
        
        const latestNotification = notifications
            .filter(it => it.message.data.type === RT_EVENT_TYPE_UPDATE_CREDITS)
            .sort((a, b) => new Date(b.message.data.data.createdAt) - new Date(a.message.data.data.createdAt))[0]
        
        if (!latestNotification) return
        
        const currCredits ={ ...credits }
        const { credits: nextCredits, target } = latestNotification.message.data.data
        
        setCredits({
            ...currCredits,
            ...nextCredits,
        })
        
        if (nextCredits.organization !== currCredits.organization
            && target === NOTIFICATION_TARGET_ORGANIZATION) {
            
            const message = `Organization credits updated: $${nextCredits.organization.toLocaleString('en-US')}`
            
            // Prevent duplicate credits toasts by tracking the ID
            if (toastId.current)
                toast.update(toastId.current, { type: 'success', render: message })
            else
                toastId.current = toast.success(message, {
                    onClose: () => {
                        toastId.current = null
                    },
                })
            
        }
        
    }, [notifications, toastId])
    
}
